export const MAYA_INTENTS = {
  recommend_accomodation: {
    KEY: 'recommend_accomodation',
  },
  recommend_destination: {
    KEY: 'recommend_destination',
  },
  recommend_trip: {
    KEY: 'recommend_trip',
  },
  qa: {
    KEY: 'qa',
  },
  llt_qa: {
    KEY: 'llt_qa',
  },
  event: {
    KEY: 'event',
  },
  business: {
    KEY: 'business',
  },
  trending: {
    KEY: 'trending',
  },
  entity_specific_qa: {
    KEY: 'entity_specific_qa',
  },
}

export const TRANSLATIONS_TEXTS_PER_CLIENT = {
  tourtailors: {
    request_plan_cta: {
      en: 'Talk to a travel consultant',
    },
    is_plan_requested: {
      en: 'Talk to a travel consultant',
    },
  },
  lifexperiences: {
    request_plan_cta: {
      en: 'Talk to a human',
      de: 'Sprich mit einem Menschen',
      fr: 'Parlez à un humain',
    },
    is_plan_requested: {
      en: 'Talk to a human',
      de: 'Sprich mit einem Menschen',
      fr: 'Parlez à un humain',
    },
  },
  flytrip: {
    request_plan_cta: {
      en: 'Request a charter flight',
      es: 'Solicitar vuelo chárter',
    },
    is_plan_requested: {
      en: 'Request a charter flight',
      es: 'Solicitar vuelo chárter',
    },
  },
  maya: {
    request_plan_cta: {
      en: 'Book a demo',
    },
    is_plan_requested: {
      en: 'Book a demo',
    },
  },
  bestarctic: {
    request_plan_cta: {
      en: 'Talk to a human',
    },
    is_plan_requested: {
      en: 'Talk to a human',
    },
  },
  holapola: {
    request_plan_cta: {
      nl: 'Ik wil iemand van Hola Pola basecamp spreken.',
    },
    is_plan_requested: {
      nl: 'Ik wil iemand van Hola Pola basecamp spreken.',
    },
  },
  plugplugtravel: {
    generate_ai_response_cta: {
      nl: 'Genereer een antwoord',
    },
    request_plan_cta: {
      nl: `Op reis met je eigen groep?`,
    },
    is_plan_requested: {
      nl: 'Rondreis op maat aangevraagd',
    },
    search_placeholder: {
      nl: 'Zoek een reis, bestemming of andere inspiratie of stel een vraag',
    },
  },
  zoover: {
    trip_price_disclaimer: {
      nl: 'p.p vanaf',
      en: 'p.p from',
    },
    generate_ai_response_cta: {
      nl: 'Genereer een antwoord',
      en: 'Generate an answer',
    },
    request_plan_cta: {
      nl: 'Neem contact met me op',
      en: 'Get Human Assistance',
    },
    is_plan_requested: {
      nl: 'Voorstel op maat aangevraagd',
      en: 'Custom plan requested',
    },
    search_placeholder: {
      nl: 'Typ je vraag en verstuur',
      en: 'Type your query and submit',
    },
    read_more: {
      nl: 'Meer lezen',
      en: 'Read More',
    },
    read_less: {
      nl: 'Minder lezen',
      en: 'Read Less',
    },
  },
  neckermann: {
    see_recommendations_cta_title: {
      nl: 'Naar ons vakantie-aanbod',
      fr: 'Vers notre offre',
    },
    generate_ai_response_cta: {
      nl: 'Genereer een antwoord',
      fr: 'Générez une réponse',
    },
    request_plan_cta: {
      nl: 'Spreek met een medewerker',
      fr: 'Contacter un humain',
    },
    is_plan_requested: {
      nl: 'Spreek met een medewerker',
      fr: 'Contacter un humain',
    },
    search_placeholder: {
      nl: 'Typ je vraag en verstuur',
      en: 'Type your query and submit',
    },
  },
  bunkhouse: {
    generate_ai_response_cta: {
      nl: 'Genereer een antwoord',
    },
    request_plan_cta: {
      nl: `Op reis met je eigen groep?`,
    },
    is_plan_requested: {
      nl: 'Rondreis op maat aangevraagd',
    },
    search_placeholder: {
      nl: 'Zoek een reis, bestemming of andere inspiratie of stel een vraag',
    },
  },
  emaar: {
    generate_ai_response_cta: {
      en: 'Generate an answer',
    },
    request_plan_cta: {
      en: 'Get Human Assistance',
    },
    is_plan_requested: {
      en: 'Custom plan requested',
    },
  },
  travelbase: {
    generate_ai_response_cta: {
      nl: 'Genereer een antwoord',
      en: 'Generate an answer',
      fr: 'Générez une réponse',
      de: 'Generiere eine Antwort',
    },
    request_plan_cta: {
      nl: 'Vind je avontuur',
      en: 'Find your adventure',
      fr: 'Trouvez votre aventure',
      de: 'Finde dein Lieblingsabenteuer',
    },
    is_plan_requested: {
      nl: 'Contactaanvraag verstuurd',
      en: 'Contact request sent',
      fr: 'Demande de contact envoyée',
      de: 'Kontaktanfrage gesendet',
    },
    updating_recommendations_recommend_accomodation: {
      fr: ['Je réfléchis à votre question'],
    },
    updating_recommendations_recommend_destination: {
      fr: ['Je réfléchis à votre question'],
    },
    updating_recommendations_qa: {
      fr: ['Je réfléchis à votre question'],
    },
    updating_recommendations_recommend_trip: {
      fr: ['Je réfléchis à votre question'],
    },
    updating_recommendations_event: {
      fr: ['Je réfléchis à votre question'],
    },
    updating_recommendations_business: {
      fr: ['Je réfléchis à votre question'],
    },
    updating_recommendations_trending: {
      fr: ['Je réfléchis à votre question'],
    },
  },
  joker: {
    generate_ai_response_cta: {
      nl: 'Genereer een antwoord',
    },
    request_plan_cta: {
      nl: 'Ik wil een reisexpert spreken',
    },
    is_plan_requested: {
      nl: 'Voorstel op maat aangevraagd',
    },
  },
  frenchmorning: {
    generate_ai_response_cta: {
      fr: 'Générez une réponse',
    },
    request_plan_cta: {
      fr: 'Abonnez-vous à notre newsletter',
    },
    is_plan_requested: {
      fr: 'Inscription à la newsletter en cours',
    },
  },
  frenchmorningcanada: {
    generate_ai_response_cta: {
      fr: 'Générez une réponse',
    },
    request_plan_cta: {
      fr: 'Abonnez-vous à notre newsletter',
    },
    is_plan_requested: {
      fr: 'Inscription à la newsletter en cours',
    },
  },
  frenchmorninglondon: {
    generate_ai_response_cta: {
      fr: 'Générez une réponse',
    },
    request_plan_cta: {
      fr: 'Abonnez-vous à notre newsletter',
    },
    is_plan_requested: {
      fr: 'Inscription à la newsletter en cours',
    },
  },
  nazar: {
    generate_ai_response_cta: {
      sv: 'Skapa ett svar',
    },
    request_plan_cta: {
      sv: 'Begär en personlig plan',
    },
    is_plan_requested: {
      sv: 'Personligt plan begärt',
    },
    search_placeholder: {
      sv: 'Skriv din fråga och skicka',
    },
  },
  aktiefski: {
    generate_ai_response_cta: {
      nl: 'Genereer een antwoord',
    },
    request_plan_cta: {
      nl: 'Liever een voorstel op maat?',
    },
    is_plan_requested: {
      nl: 'Voorstel op maat aangevraagd',
    },
  },
  laplandtravel: {
    generate_ai_response_cta: {
      nl: 'Genereer een antwoord',
      fr: 'Générez une réponse',
      de: 'Generiere eine Antwort',
    },
    request_plan_cta: {
      nl: 'Vraag een offerte aan',
      fr: 'Demande de devis',
      de: 'Angebot anfordern',
    },
    is_plan_requested: {
      nl: 'Offerte aangevraagd',
      fr: 'Devis demandée',
      de: 'Angebot angefordert',
    },
  },
  thegreenprogram: {
    generate_ai_response_cta: {
      en: 'Generate an answer',
    },
    request_plan_cta: {
      en: 'I would like to be contacted by a team member',
    },
    is_plan_requested: {
      en: 'I would like to be contacted by a team member',
    },
  },
  demo: {
    generate_ai_response_cta: {
      en: 'Generate an answer',
      nl: 'Genereer een antwoord',
      fr: 'Générez une réponse',
      de: 'Generiere eine Antwort',
      sv: 'Skapa ett svar',
    },
    request_plan_cta: {
      en: 'Request a custom plan',
      nl: 'Liever een voorstel op maat?',
      fr: 'Demander un plan personnalisé ?',
      de: 'Einen individuellen Plan anfordern?',
      sv: 'Begär en personlig plan',
    },
    is_plan_requested: {
      en: 'Custom plan requested',
      nl: 'Voorstel op maat aangevraagd',
      fr: 'Plan personnalisé demandé',
      de: 'Individuellen Plan angefordert',
      sv: 'Personligt plan begärt',
    },
    search_placeholder: {
      en: 'Type your query and submit',
      nl: 'Typ je vraag en verstuur',
      fr: 'Tapez votre requête et soumettez',
      de: 'Geben Sie Ihre Anfrage ein und senden Sie sie ab',
      sv: 'Skriv din fråga och skicka',
    },
    read_more: {
      en: 'Read More',
      nl: 'Meer lezen',
      fr: 'Lire la suite',
      de: 'Mehr lesen',
      sv: 'Läs mer',
    },
    read_less: {
      en: 'Read Less',
      nl: 'Minder lezen',
      fr: 'Lire moins',
      de: 'Weniger lesen',
      sv: 'Läs mindre',
    },
  },
  frenchly: {
    generate_ai_response_cta: {
      en: 'Generate an answer',
    },
    request_plan_cta: {
      en: 'Request a custom plan',
    },
    is_plan_requested: {
      en: 'Custom plan requested',
    },
  },
  zuiderhuis: {
    generate_ai_response_cta: {
      nl: 'Genereer een antwoord',
    },
    request_plan_cta: {
      nl: 'Ik wens een specialist te spreken',
    },
    is_plan_requested: {
      nl: 'Ik wens een specialist te spreken',
    },
    search_placeholder: {
      nl: 'Zoek naar reizen en pagina’s of stel een vraag',
    },
    read_more: {
      nl: 'Meer lezen',
    },
    read_less: {
      nl: 'Minder lezen',
    },
  },
  levelovoyageur: {
    generate_ai_response_cta: {
      en: 'Generate an answer',
      fr: 'Générez une réponse',
    },
    request_plan_cta: {
      en: 'Please ask a member of the team to contact me',
      fr: `Je souhaite être recontacté par un membre de l'équipe`,
    },
    is_plan_requested: {
      en: 'Please ask a member of the team to contact me',
      fr: `Je souhaite être recontacté par un membre de l'équipe`,
    },
  },
  noorderhuis: {
    generate_ai_response_cta: {
      nl: 'Genereer een antwoord',
    },
    request_plan_cta: {
      nl: 'Liever een voorstel op maat?',
    },
    is_plan_requested: {
      nl: 'Voorstel op maat aangevraagd in de chat',
    },
    search_placeholder: {
      nl: 'Zoek een reis, bestemming of andere inspiratie of stel een vraag',
    },
  },
  kingfisher: {
    generate_ai_response_cta: {
      nl: 'Genereer een antwoord',
    },
    request_plan_cta: {
      nl: 'Liever een voorstel op maat?',
    },
    is_plan_requested: {
      nl: 'Voorstel op maat aangevraagd',
    },
  },
  odysseus: {
    generate_ai_response_cta: {
      nl: 'Genereer een antwoord',
    },
    request_plan_cta: {
      nl: 'Graag een voorstel op maat?',
    },
    is_plan_requested: {
      nl: 'Voorstel op maat aangevraagd',
    },
  },
  odysseus_b2b: {
    generate_ai_response_cta: {
      nl: 'Genereer een antwoord',
    },
    request_plan_cta: {
      nl: 'Graag een voorstel op maat?',
    },
    is_plan_requested: {
      nl: 'Voorstel op maat aangevraagd',
    },
  },
}

export const TRANSLATIONS_TEXTS = {
  maya_typing_messages: {
    en: [' Looking up information', 'Thinking', 'Formulating Answer'],
    nl: ['Informatie opzoeken', 'Nadenken', 'Antwoord formuleren'],
    fr: ["Recherche d'informations", 'Réflexion', 'Formulation de la réponse'],
    de: ['Informationen suchen', 'Denken', 'Antwort formulieren'],
    tr: ['Bilgi arıyor', 'Düşünüyor', 'Cevabı düzenliyor'],
    sv: ['Sökning efter information', 'Tänkande', 'Formulering av svar'],
    es: ['Buscando información', 'Pensando', 'Formulando respuesta'],
  },
  maya_typing_text: {
    en: 'Reasoning',
    nl: 'Redeneren',
    fr: 'Raisonnement',
    de: 'Begründung',
    tr: 'Nedenleme',
    es: 'Razonamiento',
  },
  generate_ai_response_cta: {
    en: 'Generate an answer',
    nl: 'Genereer een antwoord',
    fr: 'Générez une réponse',
    de: 'Generiere eine Antwort',
    tr: 'Bir cevap üret',
    sv: 'Skapa ett svar',
    es: 'Generar una respuesta',
  },
  request_plan_cta: {
    en: 'Request a custom plan',
    nl: 'Liever een voorstel op maat?',
    fr: 'Demander un plan personnalisé ?',
    de: 'Einen individuellen Plan anfordern?',
    tr: 'Bir özel plan istek',
    sv: 'Begär en personlig plan',
    es: 'Solicitar un plan personalizado',
  },
  is_plan_requested: {
    en: 'Custom plan requested',
    nl: 'Voorstel op maat aangevraagd',
    fr: 'Plan personnalisé demandé',
    de: 'Individuellen Plan angefordert',
    sv: 'Personligt plan begärt',
    es: 'Plan personalizado solicitado',
  },
  search_placeholder: {
    en: 'Type your query and submit',
    nl: 'Typ je vraag en verstuur',
    fr: 'Tapez votre requête et soumettez',
    de: 'Geben Sie Ihre Anfrage ein und senden Sie sie ab',
    sv: 'Skriv din fråga och skicka',
    es: 'Escribe tu consulta y envía',
  },
  read_more: {
    en: 'Read More',
    nl: 'Meer lezen',
    fr: 'Lire la suite',
    de: 'Mehr lesen',
    sv: 'Läs mer',
    es: 'Leer más',
  },
  read_less: {
    en: 'Read Less',
    nl: 'Minder lezen',
    fr: 'Lire moins',
    de: 'Weniger lesen',
    sv: 'Läs mindre',
    es: 'Leer menos',
  },
  always_online: {
    en: 'Always Online',
    nl: 'Altijd online',
    fr: 'Toujours en ligne',
    de: 'Immer Online',
    tr: 'Her zaman Online',
    sv: 'Alltid Online',
    es: 'Siempre en línea',
  },
  leave_feedback: {
    en: 'Leave feedback',
    nl: 'Feedback achterlaten',
    fr: 'Laissez un avis',
    de: 'Hinterlasse dein Feedback',
    tr: 'Geri bildirim bırak',
    sv: 'Lämna feedback',
    es: 'Dejar feedback',
  },
  good_response: {
    en: 'Good response',
    nl: 'Goed antwoord',
    fr: 'Bonne réponse',
    de: 'Gute Antwort',
    tr: 'İyi cevap',
    sv: 'Bra svar',
    es: 'Respuesta buena',
  },
  bad_response: {
    en: 'Bad response',
    nl: 'Slecht antwoord',
    fr: 'Mauvaise réponse',
    de: 'Schlechte Antwort',
    tr: 'Kötü cevap',
    sv: 'Dåligt svar',
    es: 'Respuesta mala',
  },
  feedback_saving_text: {
    en: 'Saving your feedback...',
    nl: 'Bezig met het opslaan van uw feedback...',
    fr: 'Enregistrement de votre feedback...',
    de: 'Speichern Sie Ihre Rückmeldung...',
    tr: 'Geri bildiriminizi kaydediyoruz...',
    sv: 'Sätta in din återkoppling...',
    es: 'Guardando tu feedback...',
  },
  feedback_success_text: {
    en: 'Feedback received successfully',
    nl: 'Feedback succesvol ontvangen',
    fr: 'Feedback reçu avec succès',
    de: 'Feedback erfolgreich erhalten',
    tr: 'Geri bildirim başarıyla alındı',
    sv: 'Återkoppling mottagen',
    es: 'Feedback recibido correctamente',
  },
  feedback_text: {
    en: 'Overall, how would you rate your chat experience?',
    nl: 'Hoe beoordeel je deze chat ervaring?',
    fr: 'Globalement, comment évaluez-vous votre expérience de chat ?',
    de: 'Wie zufrieden bist du mit deiner Chat-Erfahrung?',
    tr: 'Genel olarak, sohbet deneyiminizi nasıl değerlendirirsiniz?',
    sv: 'I övrigt, hur skulle du uppskatta din chattillfälle?',
    es: 'En general, ¿cómo evaluarías tu experiencia de chat?',
  },
  show_more: {
    en: 'Show more',
    nl: 'Meer weergeven',
    fr: 'Afficher plus',
    de: 'Mehr anzeigen',
    tr: 'Daha fazla göster',
    sv: 'Visa mer',
    es: 'Mostrar más',
  },
  show_less: {
    en: 'Show less',
    nl: 'Minder weergeven',
    fr: 'Afficher moins',
    de: 'Weniger anzeigen',
    tr: 'Daha az göster',
    sv: 'Visa mindre',
    es: 'Mostrar menos',
  },
  ai_search_query_response_placeholder: {
    en: 'Type a question and you will get an AI-generated answer here',
    nl: 'Stel een vraag en je krijgt hier een AI-gegenereerd antwoord.',
    fr: 'Tapez une question et vous obtiendrez une réponse générée par IA ici',
    de: 'Geben Sie eine Frage ein und Sie erhalten hier eine KI-generierte Antwort',
    tr: 'Bir soru yazın ve burada yapay zeka tarafından oluşturulmuş bir cevap alacaksınız',
    sv: 'Skriv en fråga så får du ett AI-genererat svar här',
    es: 'Escribe una pregunta y obtendrás una respuesta generada por IA aquí',
  },
  fetching_search: {
    en: ['Fetching search results'],
    nl: ['Zoekresultaten ophalen'],
    fr: ['Récupération des résultats de recherche'],
    de: ['Suchergebnisse abrufen'],
    tr: ['Arama sonuçlarını getirme'],
    sv: ['Hämtar sökresultat'],
    es: ['Recuperando resultados de búsqueda'],
  },
  fetching_chat: {
    en: ['Fetching Chat!'],
    nl: ['Chat ophalen!'],
    fr: ['Chat de charme!'],
    de: ['Abruf Chat'],
    tr: ['Çekici Sohbet!'],
    sv: ['Hämtar chatt!'],
    es: ['Recuperando chat!'],
  },
  updating_recommendations_recommend_accomodation: {
    en: ['Updating recommendations'],
    nl: ['Aanbevelingen bijwerken'],
    fr: ['Mise à jour des recommandations'],
    de: ['Aktualisierung der Empfehlungen'],
    tr: ['Tavsiyelerin güncellenmesi'],
    sv: ['Uppdaterar rekommendationer'],
    es: ['Actualizando recomendaciones'],
  },
  updating_recommendations_recommend_destination: {
    en: ['Updating recommendations'],
    nl: ['Aanbevelingen bijwerken'],
    fr: ['Mise à jour des recommandations'],
    de: ['Aktualisierung der Empfehlungen'],
    tr: ['Tavsiyelerin güncellenmesi'],
    sv: ['Uppdaterar rekommendationer'],
    es: ['Actualizando recomendaciones'],
  },
  updating_recommendations_qa: {
    en: ['Updating recommendations'],
    nl: ['Aanbevelingen bijwerken'],
    fr: ['Mise à jour des recommandations'],
    de: ['Aktualisierung der Empfehlungen'],
    tr: ['Tavsiyelerin güncellenmesi'],
    sv: ['Uppdaterar rekommendationer'],
    es: ['Actualizando recomendaciones'],
  },
  updating_recommendations_recommend_trip: {
    en: ['Updating trip recommendations'],
    nl: ['We updaten je persoonlijke aanbevelingen'],
    fr: ['Mise à jour des recommandations de voyage'],
    de: ['Aktualisierung der Reiseempfehlungen'],
    tr: ['Gezi önerilerinin güncellenmesi'],
    sv: ['Uppdaterar reseförslag'],
    es: ['Actualizando recomendaciones'],
  },
  updating_recommendations_recommend_destination: {
    en: ['Updating destination recommendations'],
    nl: ['Bestemmingsaanbevelingen bijwerken'],
    fr: ['Mise à jour des recommandations de destination'],
    de: ['Hedef önerilerinin güncellenmesi'],
    tr: ['Destinasyon önerilerinin güncellenmesi'],
    sv: ['Uppdaterar destinationsrekommendationer'],
    es: ['Actualizando recomendaciones'],
  },
  updating_recommendations_event: {
    en: ['Updating recommendations'],
    nl: ['Aanbevelingen bijwerken'],
    fr: ['Mise à jour des recommandations'],
    de: ['Aktualisierung der Empfehlungen'],
    tr: ['Tavsiyelerin güncellenmesi'],
    sv: ['Uppdaterar rekommendationer'],
    es: ['Actualizando recomendaciones'],
  },
  updating_recommendations_business: {
    en: ['Updating recommendations'],
    nl: ['Aanbevelingen bijwerken'],
    fr: ['Mise à jour des recommandations'],
    de: ['Aktualisierung der Empfehlungen'],
    tr: ['Tavsiyelerin güncellenmesi'],
    sv: ['Uppdaterar rekommendationer'],
    es: ['Actualizando recomendaciones'],
  },
  updating_recommendations_trending: {
    en: ['Updating recommendations'],
    nl: ['Aanbevelingen bijwerken'],
    fr: ['Mise à jour des recommandations'],
    de: ['Aktualisierung der Empfehlungen'],
    tr: ['Tavsiyelerin güncellenmesi'],
    sv: ['Uppdaterar rekommendationer'],
    es: ['Actualizando recomendaciones'],
  },
  chat_placeholder: {
    en: 'Type here',
    nl: 'Schrijf je bericht hier',
    fr: 'Tapez ici',
    de: 'Schreib hier',
    tr: 'Buraya yazın',
    sv: 'Skriv här',
    es: 'Escribe aquí',
  },
  recommend_trip_cta: {
    en: 'See trips',
    nl: 'Trips bekijken',
    fr: 'Voir les voyages',
    de: 'Reisen ansehen',
    tr: 'Gezileri görün',
    sv: 'Se resor',
    es: 'Ver viajes',
  },
  recommend_destination_cta: {
    en: 'See Destinations',
    nl: 'Bestemmingen bekijken',
    fr: 'Voir les destinations',
    de: 'Ziele ansehen',
    tr: 'Destinasyonları Gör',
    sv: 'Se destinationer',
    es: 'Ver destinos',
  },
  recommend_trip_tab: {
    en: 'Trips',
    nl: 'Trips',
    fr: 'Voyages',
    de: 'Reisen',
    tr: 'Geziler',
    sv: 'Resor',
    es: 'Viajes',
  },
  recommend_destination_tab: {
    en: 'Recommendations',
    nl: 'Aanbevelingen',
    fr: 'Recommandations',
    de: 'Empfehlungen',
    tr: 'Tavsiyeler',
    sv: 'Rekommendationer',
    es: 'Recomendaciones',
  },
  recommend_accomodation_tab: {
    en: 'Recommendations',
    nl: 'Aanbevelingen',
    fr: 'Recommandations',
    de: 'Empfehlungen',
    tr: 'Tavsiyeler',
    sv: 'Rekommendationer',
    es: 'Recomendaciones',
  },
  qa_tab: {
    en: 'Recommendations',
    nl: 'Aanbevelingen',
    fr: 'Recommandations',
    de: 'Empfehlungen',
    tr: 'Tavsiyeler',
    sv: 'Rekommendationer',
    es: 'Recomendaciones',
  },
  event_tab: {
    en: 'Recommendations',
    nl: 'Aanbevelingen',
    fr: 'Recommandations',
    de: 'Empfehlungen',
    tr: 'Tavsiyeler',
    sv: 'Rekommendationer',
    es: 'Recomendaciones',
  },
  business_tab: {
    en: 'Recommendations',
    nl: 'Aanbevelingen',
    fr: 'Recommandations',
    de: 'Empfehlungen',
    tr: 'Tavsiyeler',
    sv: 'Rekommendationer',
    es: 'Recomendaciones',
  },
  trending_tab: {
    en: 'Recommendations',
    nl: 'Aanbevelingen',
    fr: 'Recommandations',
    de: 'Empfehlungen',
    tr: 'Tavsiyeler',
    sv: 'Rekommendationer',
    es: 'Recomendaciones',
  },
  read_more: {
    en: 'Read More',
    nl: 'Meer lezen',
    fr: 'Lire la suite',
    de: 'Mehr lesen',
    tr: 'Daha fazla bilgi edinin',
    sv: 'Läs mer',
    es: 'Leer más',
  },
  regenerate_response: {
    en: 'Something went wrong. Regenerate response?',
    nl: 'Er ging iets fout. Wil je opnieuw proberen?',
    fr: "Quelque chose s'est mal passé. Regénérer la réponse?",
    de: 'Etwas ist schief gelaufen. Antwort neu generieren?',
    tr: 'Bir şeyler ters gitti. Rejenerasyon tepkisi mi?',
    sv: 'Något gick fel. Generera svaret igen?',
    es: 'Algo salió mal. ¿Deseas generar una respuesta nuevamente?',
  },
  see_recommendations_cta_title: {
    en: 'See recommendations',
    nl: 'Zie aanbevelingen',
    fr: 'Voir les recommandations',
    de: 'Empfehlungen ansehen',
    tr: 'Önerilere bakın',
    sv: 'Se rekommendationer',
    es: 'Ver recomendaciones',
  },
  see_events_cta: {
    en: 'See all events',
    nl: 'Bekijk alle events',
    fr: 'Voir tous les événements',
    de: 'Alle Veranstaltungen ansehen',
    tr: 'Tüm etkinlikleri görün',
    sv: 'Se alla evenemang',
    es: 'Ver todos los eventos',
  },
  continue_chat_cta: {
    en: 'Continue chatting',
    nl: 'Chat verder',
    fr: 'Continuer à discuter',
    de: 'Weiter ch',
    tr: 'Sohbete devam edin',
    sv: 'Fortsätt chatta',
    es: 'Continuar chat',
  },
  random_trips_grid_message: {
    en: 'We don’t have any trips with your exact requirements, but we can recommend the following alternatives:',
    nl: 'We hebben geen reizen met jouw exacte eisen, maar we kunnen deze aanbevelen:',
    fr: "Nous n'avons pas de voyages avec vos exigences exactes, mais nous pouvons recommander les alternatives suivantes:",
    de: 'Wir haben keine Reisen mit Ihren genauen Anforderungen, aber wir können die folgenden Alternativen empfehlen:',
    tr: 'Tam olarak sizin gereksinimlerinize uygun bir seyahatimiz yok, ancak aşağıdaki alternatifleri önerebiliriz:',
    sv: 'Vi har inga resor med dina exakta krav, men vi kan rekommendera följande alternativ:',
    es: 'No tenemos ningún viaje con tus exactas exigencias, pero podemos recomendarte los siguientes alternativos:',
  },
  departure_dates: {
    en: 'Departure Dates',
    nl: 'Vertrekdata',
    fr: 'Dates de départ',
    de: 'Abreisedaten',
    tr: 'Kalkış Tarihleri',
    sv: 'Avresedatum',
    es: 'Fechas de salida',
  },
  reviews: {
    en: 'Reviews',
    nl: 'Beoordelingen',
    fr: 'Témoignages',
    de: 'Bewertungen',
    tr: 'Yorumlar',
    sv: 'Recensioner',
    es: 'Reseñas',
  },
  relevancy_info: {
    partial_match: {
      en: 'Partial match',
      nl: 'Gedeeltelijke overeenkomst met zoekopdracht',
      fr: 'Correspondance partielle',
      de: 'Teilübereinstimmung',
      tr: 'Kısmi eşleşme',
      sv: 'Delvis matchning',
      es: 'Coincidencia parcial',
    },
    exact_match: {
      en: 'Exact match',
      nl: 'Exacte match',
      fr: 'Correspondance exacte',
      de: 'Exakte Übereinstimmung',
      tr: 'Tam eşleşme',
      sv: 'Exakt matchning',
      es: 'Coincidencia exacta',
    },
  },
  no_search_results: {
    en: 'No search results found',
    nl: 'Geen zoekresultaten gevonden',
    fr: 'Aucun résultat de recherche trouvé',
    de: 'Keine Suchergebnisse gefunden',
    tr: 'Arama sonuçları bulunamadı',
    sv: 'Inga skresultat hittades',
    es: 'No se encontraron resultados de búsqueda',
  },
  send_chat_to_email: {
    en: 'Send chat to my email',
    nl: 'Chat verzenden naar mijn email',
    fr: 'Envoyer le chat à mon email',
    de: 'Chat an meine E-Mail senden',
    sv: 'Skicka chat till min e-post',
    tr: 'Sohbeti e-posta gönder',
    es: 'Enviar chat a mi email',
  },
  email: {
    en: 'Email',
    nl: 'E-mail',
    fr: 'Email',
    de: 'Email',
    tr: 'Email',
    sv: 'Email',
    es: 'Email',
  },
  send_chat: {
    en: 'Send chat',
    nl: 'Chat verzenden',
    fr: 'Envoyer le chat',
    de: 'Chat senden',
    tr: 'Sohbet gönder',
    sv: 'Skicka chat',
    es: 'Enviar chat',
  },
  send_chat_sending: {
    en: 'Sending...',
    nl: 'Verzenden...',
    fr: 'Envoi...',
    de: 'Senden...',
    sv: 'Skickar...',
    tr: 'Gönderiliyor...',
    es: 'Enviando...',
  },
  refresh: {
    en: 'Refresh',
    nl: 'Vernieuwen',
    fr: 'Rafraîchir',
    de: 'Aktualisieren',
    tr: 'Yenile',
    sv: 'Uppdatera',
    es: 'Refrescar',
  },
  full_screen: {
    en: 'Full screen',
    nl: 'Volledig scherm',
    fr: 'Plein écran',
    de: 'Vollbild',
    tr: 'Tam ekran',
    sv: 'Helskärm',
    es: 'Pantalla completa',
  },
  chat_sent_successfully: {
    en: 'Chat sent successfully!',
    nl: 'Chat succesvol verzonden!',
    fr: 'Chat envoyé avec succès!',
    de: 'Chat erfolgreich gesendet!',
    tr: 'Sohbet başarıyla gönderildi!',
    sv: 'Chat skickad!',
    es: 'Chat enviado correctamente!',
  },
  chat_sent_error: {
    en: 'Error sending chat!',
    nl: 'Fout bij het verzenden van de chat!',
    fr: "Erreur lors de l'enregistrement du chat!",
    de: 'Fehler beim Senden des Chats!',
    tr: 'Sohbet gönderimi hatası!',
    sv: 'Fel vid skickande av chat!',
    es: 'Error al enviar el chat!',
  },
  quick_search_in_progress: {
    en: 'Search in progress',
    nl: 'Er wordt gezocht',
    fr: 'Recherche en cours',
    de: 'Suche läuft',
    tr: 'Arama devam ediyor',
    sv: 'Letar efter',
    es: 'Buscando',
  },
}

export const TRIP_AVAILIBILITY_STATUSES = {
  guaranteed: ['gegarandeerd', 'guaranteed'],
  available: ['beschikbaar', 'available'],
  full: ['volzet', 'full', 'vol'],
  cancelled: ['canceled', 'cancelled', 'afgezegd'],
  nearly_full: ['nearly full', 'bijna vol'],
}
